const RESET_PASSWORD_EMAIL_SUCCESS_TEXT = "Un e-mail vous a été envoyé.";
const RESET_PASSWORD_CONFIRM_SUCCESS_TEXT = "Votre mot de passe a bien été modifié.";
const UPDATE_USER_SETTINGS_SUCCESS_TEXT = "Vos paramètres utilisateur ont bien été modifiés.";
const UPDATE_USER_PASSWORD_SUCCESS_TEXT = "Votre mot de passe a bien été modifié.";

export const RESET_PASSWORD_EMAIL_SUCCESS = RESET_PASSWORD_EMAIL_SUCCESS_TEXT;
export const RESET_PASSWORD_CONFIRM_SUCCESS = RESET_PASSWORD_CONFIRM_SUCCESS_TEXT;
export const UPDATE_USER_SETTINGS_SUCCESS = UPDATE_USER_SETTINGS_SUCCESS_TEXT;
export const UPDATE_USER_PASSWORD_SUCCESS = UPDATE_USER_PASSWORD_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/authentication.js